import React, { useEffect, useRef, useState } from 'react';

// Keep the current post steady while it is being read. Once offscreen, a seen
// card leaves the vertical feed; its data stays available to an open swipe viewer.
export default function UnseenPost({seen, children, id}) {
 const element = useRef(null);
 const [hidden,setHidden] = useState(false);
 useEffect(() => {
  if (!seen || hidden || !element.current) return;
  const node = element.current;
  const rect = node.getBoundingClientRect();
  if (document.querySelector('.post-status-viewer') || rect.bottom <= 0 || rect.top >= window.innerHeight) {
   setHidden(true); return;
  }
  if (!window.IntersectionObserver) return;
  const observer = new IntersectionObserver(([entry]) => {
   if (!entry.isIntersecting) setHidden(true);
  });
  observer.observe(node);
  return () => observer.disconnect();
 }, [seen,hidden]);
 return hidden ? null : <article className="post-parent" id={id} ref={element}>{children}</article>;
}
